import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import Insight from 'enums/Insight'
import Sentiment from 'enums/Sentiment'
import InsightType from 'enums/InsightType'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedSentimentDriver === undefined ||
  widgetSetting.includedSentimentDriver === null ||
  widgetSetting.includedSentimentDriver.sentiments === undefined ||
  widgetSetting.includedSentimentDriver.sentiments.length === 0

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) =>
  insights.length > applicationSettings.analysisMaxSentimentDrivers

const resolveInsight = (insightType: string | null | undefined) => {
  switch (insightType) {
    case InsightType.LIKES:
    case InsightType.DISLIKES:
      return Insight.ATTRIBUTE

    case InsightType.POSITIVE_EMOTIONS:
    case InsightType.NEGATIVE_EMOTIONS:
      return Insight.EMOTION

    case InsightType.POSITIVE_BEHAVIORS:
    case InsightType.NEGATIVE_BEHAVIORS:
      return Insight.BEHAVIOR

    default:
      throw new Error(`Unsupported insight type: ${insightType}`)
  }
}

const resolveSentiment = (insightType: string | null | undefined) => {
  switch (insightType) {
    case InsightType.LIKES:
    case InsightType.POSITIVE_EMOTIONS:
    case InsightType.POSITIVE_BEHAVIORS:
      return Sentiment.POSITIVE

    case InsightType.DISLIKES:
    case InsightType.NEGATIVE_EMOTIONS:
    case InsightType.NEGATIVE_BEHAVIORS:
      return Sentiment.NEGATIVE

    default:
      throw new Error(`Unsupported insight type: ${insightType}`)
  }
}

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => {
  const { name, variants, insightType } = insights[0]

  return {
    ...widgetSetting,
    includedSentimentDriver: {
      insights: [resolveInsight(insightType)],
      sentiments: [resolveSentiment(insightType)],
      terms: [name, ...(variants || [])]
    }
  }
}

const generateIncludedSentimentDriverStrategy = (
  applicationSettings: any
): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateIncludedSentimentDriverStrategy
